import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_key, Base_URL } from "src/apiConstants";

import classes from "./HomePage.module.css";
import "react-multi-carousel/lib/styles.css";

import CarouselSlider from "../../shared/CarouselSlider";
import Loader from "../../shared/Loader";

import { Movie } from "src/types/movieData";
import { TvShow } from "src/types/tvSeriesData";
import { Person } from "src/types/personData";
import cn from "classnames";

const HomePage = () => {
  const [trendingMoviesType, setTrendingMoviesType] = useState(1);
  const [trendingTvType, setTrendingTvType] = useState(1);
  const [trendingPeopleType, setTrendingPeopleType] = useState(1);

  const [moviesDayData, setMoviesDayData] = useState<Movie[] | null>(null);
  const [moviesWeekData, setMoviesWeekData] = useState<Movie[] | null>(null);

  const [tvDayData, setTvDayData] = useState<TvShow[] | null>(null);
  const [tvWeekData, setTvWeekData] = useState<TvShow[] | null>(null);

  const [peopleDayData, setPeopleDayData] = useState<Person[] | null>(null);
  const [peopleWeekData, setPeopleWeekData] = useState<Person[] | null>(null);

  const URL = `${Base_URL}/trending/movie/day?${API_key}&language=en-US`;
  const URL1 = `${Base_URL}/trending/movie/week?${API_key}&language=en-US`;
  const URL2 = `${Base_URL}/trending/tv/day?${API_key}&language=en-US`;
  const URL3 = `${Base_URL}/trending/tv/week?${API_key}&language=en-US`;
  const URL4 = `${Base_URL}/trending/person/day?${API_key}&language=en-US`;
  const URL5 = `${Base_URL}/trending/person/week?${API_key}&language=en-US`;

  useEffect(() => {
    axios.get(URL).then((response) => setMoviesDayData(response.data.results));
    axios
      .get(URL1)
      .then((response) => setMoviesWeekData(response.data.results));
    axios.get(URL2).then((response) => setTvDayData(response.data.results));
    axios.get(URL3).then((response) => setTvWeekData(response.data.results));
    axios.get(URL4).then((response) => setPeopleDayData(response.data.results));
    axios
      .get(URL5)
      .then((response) => setPeopleWeekData(response.data.results));
  }, [URL, URL1, URL2, URL3, URL4, URL5]);

  if (
    !moviesDayData ||
    !moviesWeekData ||
    !tvDayData ||
    !tvWeekData ||
    !peopleDayData ||
    !peopleWeekData
  ) {
    return <Loader />;
  }

  return (
    <div className={classes.home}>
      <section className={classes.carousel}>
        <div className={classes.homeTabs}>
          <h4 className={classes.heading}>Trending Movies: </h4>
          <h4
            className={cn(
              classes.heading_1,
              trendingMoviesType === 1 && classes.active,
            )}
            onClick={() => setTrendingMoviesType(1)}
          >
            today
          </h4>
          <h4
            className={cn(
              classes.heading_2,
              trendingMoviesType === 2 && classes.active,
            )}
            onClick={() => setTrendingMoviesType(2)}
          >
            this week{" "}
          </h4>
        </div>
        <div className={classes.carouselDisplay}>
          {trendingMoviesType === 1 && (
            <div>
              <CarouselSlider movies={moviesDayData} />
            </div>
          )}
          {trendingMoviesType === 2 && (
            <div>
              <CarouselSlider movies={moviesWeekData} />
            </div>
          )}
        </div>
      </section>

      <section className={classes.carousel}>
        <div className={classes.homeTabs}>
          <h4 className={classes.heading}>Trending Shows: </h4>
          <h4
            className={cn(
              classes.heading_1,
              trendingTvType === 1 && classes.active,
            )}
            onClick={() => setTrendingTvType(1)}
          >
            today
          </h4>
          <h4
            className={cn(
              classes.heading_2,
              trendingTvType === 2 && classes.active,
            )}
            onClick={() => setTrendingTvType(2)}
          >
            this week{" "}
          </h4>
        </div>
        <div className={classes.carouselDisplay}>
          {trendingTvType === 1 && <CarouselSlider shows={tvDayData} />}
          {trendingTvType === 2 && <CarouselSlider shows={tvWeekData} />}
        </div>
      </section>
      <section className={classes.carousel}>
        <div className={classes.homeTabs}>
          <h4 className={classes.heading}>Trending People: </h4>
          <h4
            className={cn(
              classes.heading_1,
              trendingPeopleType === 1 && classes.active,
            )}
            onClick={() => setTrendingPeopleType(1)}
          >
            today
          </h4>
          <h4
            className={cn(
              classes.heading_2,
              trendingPeopleType === 2 && classes.active,
            )}
            onClick={() => setTrendingPeopleType(2)}
          >
            this week{" "}
          </h4>
        </div>{" "}
        <div className={classes.carouselDisplay}>
          {trendingPeopleType === 1 && (
            <div>
              <CarouselSlider people={peopleDayData} />
            </div>
          )}
          {trendingPeopleType === 2 && (
            <div>
              <CarouselSlider people={peopleWeekData} />
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default HomePage;
